import React, { useState } from 'react'

const Input = ({ type, value, name, onChange, placeholder, id, label, className, minLength, maxLength, pattern, disabled, required, checked }) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prevState) => !prevState);
  }
  return (
    <>
      <label>{label}</label>
      <input type={type} name={name} value={value} placeholder={placeholder} onChange={onChange} id={id} className={className} minLength={minLength} maxLength={maxLength} required={required} pattern={pattern} disabled={disabled} checked={checked}
      />
      {type === "checkbox" && (
        <label htmlFor={id}>
          &nbsp;I agree to the <a href="/terms-and-conditions">Terms and Conditions</a>
        </label>
      )}
    </>
  )
}

export default Input
